import {useEffect, useRef, useMemo} from 'react';

type YandexMetrikaUserParams = {
    user_id: number | null;
    email_confirmed: boolean | null;
    created_at: string | null;
    last_activity_at: string | null;
    timezone: string | null;
    tariff_id: number | null;
    tariff_name: string | null;
    tariff_is_archive: boolean | null;
    is_recurring: boolean | null;
    monitors_count: number | null;
    monitors_with_incidents_count: number | null;
    last_email_error: string | null;
    agree_to_newsletter: boolean | null;
    has_payments: boolean | null;
};

export const useYandexMetrika = (userData: any) => {
    const prevParamsRef = useRef<YandexMetrikaUserParams | null>(null);

    // Вычисляем параметры один раз при изменении userData
    const metrikaParams = useMemo(() => {
        if (!userData) return null;

        return {
            user_id: userData.id || null,
            email_confirmed: userData.email_confirmed || null,
            created_at: userData.created_at ? new Date(userData.created_at).toISOString() : null,
            last_activity_at: userData.last_activity_at ? new Date(userData.last_activity_at).toISOString() : null,
            timezone: userData.timezone || null,
            tariff_id: userData.tariff?.id || null,
            tariff_name: userData.tariff?.name || null,
            tariff_is_archive: userData.tariff?.is_archive || null,
            is_recurring: userData.is_recurring || null,
            monitors_count: userData.monitors_count || null,
            monitors_with_incidents_count: userData.monitors_with_incidents_count || null,
            last_email_error: userData.last_email_error || null,
            agree_to_newsletter: userData.agree_to_newsletter || null,
            has_payments: userData.has_payments || null,
        };
    }, [userData]);

    useEffect(() => {
        if (!metrikaParams) return;

        const requiredFields: (keyof YandexMetrikaUserParams)[] = ['user_id'];
        const hasAllRequiredFields = requiredFields.every(field => metrikaParams[field] !== null);

        // Сравниваем с предыдущими параметрами
        if (hasAllRequiredFields &&
            window.yaCounter94769067 &&
            JSON.stringify(metrikaParams) !== JSON.stringify(prevParamsRef.current)) {

            window.yaCounter94769067.userParams(metrikaParams);
            prevParamsRef.current = metrikaParams;
        }
    }, [metrikaParams]);
};